export default [
  {
    path: '/hotel',
    name: 'hotel',
    component: () => import('@/components/hotel/Main.vue'),
    redirect: { name: 'hotel_profile' },

    children: [
      // {
      //   path: 'categorization',
      //   name: 'hotel_categorizations-list',
      //   component: () => import('@/components/hotel/RequestsList.vue'),
      //   meta: {
      //     isMenu: true,
      //   },
      // },
      {
        path: 'profile',
        name: 'hotel_profile',
        component: () => import('@/components/hotel/Profile.vue'),
        meta: {
          isMenu: true,
        },
      },
      {
        path: 'notification',
        name: 'hotel_tour-operator_notifications',
        component: () => import('@/components/general/Notifications.vue'),
        meta: {
          isMenu: true,
        },
      },
      // {
      //   path: 'categorization',
      //   name: 'hotel_categorization',
      //   component: () => import('@/components/hotel/Categorization.vue'),
      //   meta: {
      //     isMenu: false,
      //     name: 'categorization_request',
      //   },
      // },
      // {
      //   path: 'categorization/create',
      //   name: 'hotel_categorization-create',
      //   component: () => import('@/components/hotel/Categorization.vue'),
      //   meta: {
      //     isMenu: true,
      //   },
      // },
      // {
      //   path: 'categorization/:id',
      //   name: 'hotel_categorization-edit',
      //   component: () => import('@/components/hotel/Categorization.vue'),
      //   meta: {
      //     isMenu: true,
      //   },
      // },
      // ======== for deep pages
      // {
      //   path: 'create-news',
      //   name: 'content_administrator-create-news',
      //   component: () => import('@/components/content_admin/NewsPage.vue'),
      //   meta: {
      //     isMenu: false,
      //     name: 'additing_news',
      //   },
      // },
    ],
  },
];
